import React, { useEffect } from 'react'

import { Profile } from 'components'
import { getImage } from 'helpers/common'

import { useGetProfile } from '../../features/Profile'

import type { IProfile } from '../Profile'
import { useRecoilState } from 'recoil'
import { userProfileState } from 'recoils/atoms'
import defaultImage from 'assets/svg/default-image-circle.svg'

export interface NavbarProps {
  /**
   * Profile structure e.g. {
   *  profileName: nirawit,
   *  profileImage: 'https://picsum.photos/100/100',
   * }
   */
  profile?: IProfile
  /**
   * BreadCrumbs children
   */
  children?: React.ReactChild
}

export const Navbar: React.FC<NavbarProps> = ({
  children,
}: NavbarProps): JSX.Element => {
  const base = 'navbar'
  const [{ data: profileData }] = useGetProfile()
  const [userProfile, setUserProfile] = useRecoilState(userProfileState)

  useEffect(() => {
    if (profileData) {
      const { id, firstName, lastName, imagePath = '' } = profileData

      setUserProfile({
        profileId: id,
        profileName: `${firstName} ${lastName.charAt(0)}`,
        profileImage: getImage(imagePath) || defaultImage,
        profileFullName: `${firstName} ${lastName}`,
      })
    }
  }, [profileData])

  return (
    <div className={base}>
      <div className={`${base}__breadcrumbs`}>
        <div>{children}</div>

        <div className={`${base}__menu`}>
          <Profile {...userProfile} />
          {/* 
          TODO: open when translation language is ready
          <Setting /> */}
        </div>
      </div>
    </div>
  )
}

export default Navbar
